export default __webpack_public_path__ + "2ed37dbdbddf1e1cde868e8b6abca330.png";